import { Message } from "./message";

// Host controller → backend: pause or resume ONE copresenter's slide control.
// Also arrives INBOUND at the paused copresenter — that's how their clicker
// learns to switch to view-only.
//
// targetPresenterId is deliberately separate from presenterId: the latter is
// the sender (whose host status authorises the action), the former is who it
// applies to. Collapsing them would let the payload name the sender as the
// target.
export interface SetPresenterPaused extends Message {
  magicId: string;
  presenterId: string;
  targetPresenterId: string;
  paused: boolean;
}

// Host controller → backend: remove ONE copresenter from the room. Echoed to
// the removed copresenter's own sockets right before the backend closes them.
// Same sender/target split as SetPresenterPaused.
export interface RemovePresenter extends Message {
  magicId: string;
  presenterId: string;
  targetPresenterId: string;
}

// WebSocket close code the backend uses for a removed copresenter's sockets.
// Lets the clicker tell "removed" from an ordinary drop even if the
// REMOVE_PRESENTER frame before it never arrived. Mirrors
// RemovePresenterHandler.RemovedCloseCode on the backend.
export const REMOVED_CLOSE_CODE = 4001;
